/**
 * 여러 번 나눠 호출하는 발송(수신자별 반복 호출 등)을 하나의 dispatchBatchId로 묶을 때 쓴다.
 * 반복문 시작 전에 한 번만 호출해서 변수에 담아두고, 매 호출마다 같은 값을 전달한다.
 */
export function generateDispatchBatchId(): string {
  return `WEB-${crypto.randomUUID()}`;
}
